export const site = {
  name: 'Legacy Dance Studio',
  shortName: 'Legacy',
  domain: 'legacydance.com.mx',
  stagingDomain: 'pruebas.legacydance.com.mx',
  logo: '/logo_legacy_white.svg',
  nav: [
    { label: 'Clases', href: '#clases' },
    { label: 'Estilos', href: '#estilos' },
    { label: 'Eventos', href: '#eventos' },
    { label: 'Contacto', href: '#contacto' },
  ],
  hero: {
    copy: 'Clases de baile para expresarte, entrenar y crecer en comunidad.',
    primaryCta: 'Agendar clase muestra',
    secondaryCta: 'Ver horarios',
    image: '/images/legacy/hero-backstage-huddle.jpg',
  },
  features: [
    {
      title: 'Babys',
      body: 'Grupo para niñas y niños de 3 a 5 años, con clases enfocadas en coordinación, ritmo y confianza.',
      icon: 'users',
    },
    {
      title: 'Kids',
      body: 'Grupo de 8 a 11 años para desarrollar técnica, expresión y seguridad en cada clase.',
      icon: 'trophy',
    },
    {
      title: 'Seniors',
      body: 'Grupo de 12 años en adelante para entrenar con disciplina, presencia escénica y comunidad.',
      icon: 'shield',
    },
    {
      title: 'Horarios',
      body: 'Clases los lunes y miércoles de 5:00 p.m. a 8:00 p.m.',
      icon: 'calendar',
    },
  ],
  styles: [
    {
      level: 'Babys · Kids · Seniors',
      title: 'JAZZ',
      body: 'Técnica, expresión y energía en cada movimiento.',
      image: '/images/legacy/jazz-team-celebration.jpg',
      imagePosition: 'center 42%',
    },
    {
      level: 'Babys · Kids · Seniors',
      title: 'LÍRICO',
      body: 'Movimiento expresivo, musicalidad y conexión emocional.',
      image: '/images/legacy/contemporaneo-blue-portrait.jpg',
      imagePosition: 'center 45%',
    },
    {
      level: 'Babys · Kids · Seniors',
      title: 'HIP HOP',
      body: 'Ritmo, actitud y fundamentos de danza urbana.',
      image: '/images/legacy/hiphop-first-place.jpg',
      imagePosition: 'center',
    },
    {
      level: 'Babys · Kids · Seniors',
      title: 'URBANO',
      body: 'Fusión de estilos callejeros con técnica de estudio.',
      image: '/images/legacy/urbano-backstage-legacy.jpg',
      imagePosition: 'center 58%',
    },
  ],
  events: [
    {
      slug: 'universal-dance-merida-2026',
      eyebrow: 'Competencia',
      title: 'Universal Dance Mérida 2026',
      date: '2026',
      location: 'Mérida, Yucatán',
      excerpt:
        'Legacy Dance regresó a Puerto Morelos con resultados de campeonato y el orgullo de representar a su comunidad.',
      body: [
        'Con excelentes resultados y mucha emoción, Legacy Dance compartió su participación en Universal Dance Mérida 2026.',
        'Las alumnas regresaron a casa como campeonas, felices por representar a Puerto Morelos y por todo el esfuerzo dedicado a sus ensayos durante dos meses.',
        'Este logro también fue posible gracias al apoyo de las familias y a la plataforma de Universal Dance, donde las alumnas compitieron con talento de todo el país y siguieron aprendiendo en cada presentación.',
      ],
      coverImage: '/images/events/universal-dance-merida-2026.jpg',
      coverAlt:
        'Alumnas de Legacy Dance celebrando en el escenario durante Universal Dance Mérida 2026.',
      coverPosition: 'center 56%',
      gallery: [
        {
          src: '/images/events/universal-dance-merida-2026.jpg',
          alt: 'Equipo de Legacy Dance con reconocimientos en Universal Dance Mérida 2026.',
          position: 'center 56%',
        },
        {
          src: '/images/events/universal-dance-merida-2026-gallery.jpg',
          alt: 'Alumnas de Legacy Dance en presentación de competencia.',
          position: 'center 50%',
        },
      ],
    },
    {
      slug: 'danzalo-cancun-2025',
      eyebrow: 'Competencia',
      title: 'Danzalo Cancún 2025',
      date: '2025',
      location: 'Cancún, Quintana Roo',
      excerpt:
        'Primera participación de Legacy Dance en Danzalo Cancún, con aprendizajes, premios y mucha energía familiar.',
      body: [
        'Legacy Dance participó por primera vez como concursante en Danzalo Cancún 2025, una competencia que dejó grandes aprendizajes para alumnas y familias.',
        'El estudio celebró los resultados obtenidos durante el fin de semana y la emoción de ver crecer a cada grupo en el escenario.',
        'Para Legacy Dance, este evento marcó el inicio de un gran sueño construido con disciplina, comunidad y amor por la danza.',
      ],
      coverImage: '/images/events/danzalo-cancun-2025.jpg',
      coverAlt:
        'Alumnas de Legacy Dance sosteniendo reconocimientos de Danzalo Cancún 2025.',
      coverPosition: 'center 50%',
      gallery: [
        {
          src: '/images/events/danzalo-cancun-2025.jpg',
          alt: 'Grupo de Legacy Dance con premios de oro en Danzalo Cancún.',
          position: 'center 50%',
        },
        {
          src: '/images/events/danzalo-cancun-2025-gallery.jpg',
          alt: 'Alumnas de Legacy Dance posando durante Danzalo Cancún 2025.',
          position: 'center 50%',
        },
      ],
    },
    {
      slug: 'primer-showcase-legacy-dance',
      eyebrow: 'Showcase',
      title: '1er Showcase Legacy Dance',
      date: 'Julio 2025',
      location: 'Puerto Morelos, Quintana Roo',
      excerpt:
        'El primer evento de fin de cursos reunió a alumnos, familias y staff en un cierre de ciclo lleno de escenario.',
      body: [
        'Así se vivió el primer evento de fin de cursos de Legacy Dance, un momento especial para celebrar el avance de las alumnas y cerrar el ciclo en comunidad.',
        'El estudio agradeció a todos los alumnos, a las familias que acompañaron y al staff del GO Riviera Maya por abrir el espacio para esta presentación.',
        'Este showcase representa solo el inicio de una historia que sigue creciendo con cada clase, ensayo y presentación.',
      ],
      coverImage: '/images/events/showcase-legacy-dance-2025.jpg',
      coverAlt: 'Alumnas de Legacy Dance sobre el escenario durante su primer showcase.',
      coverPosition: 'center 48%',
      gallery: [
        {
          src: '/images/events/showcase-legacy-dance-2025.jpg',
          alt: 'Alumnas de Legacy Dance listas para presentarse en el showcase.',
          position: 'center 48%',
        },
        {
          src: '/images/events/showcase-legacy-dance-2025-gallery.jpg',
          alt: 'Presentación del primer showcase de Legacy Dance.',
          position: 'center 50%',
        },
      ],
    },
    {
      slug: 'universal-dance-merida-mayo-2025',
      eyebrow: 'Competencia',
      title: 'Universal Dance Mérida Mayo 2025',
      date: 'Mayo 2025',
      location: 'Mérida, Yucatán',
      excerpt:
        'La primera competencia de Legacy Dance marcó el inicio de una historia de esfuerzo, premios y crecimiento.',
      body: [
        'Universal Dance Mérida Mayo 2025 fue el inicio de una gran historia para Legacy Dance: su primera competencia como estudio.',
        'El equipo regresó a casa feliz y orgulloso por los resultados, los premios y las medallas, pero sobre todo por el esfuerzo de cada alumna para llegar hasta el escenario.',
        'Las familias fueron parte fundamental de este logro, acompañando cada ensayo, cada preparación y cada paso de esta primera experiencia competitiva.',
      ],
      coverImage: '/images/events/universal-dance-merida-mayo-2025-card.jpg',
      coverAlt: 'Alumnas de Legacy Dance presentándose en Universal Dance Mérida 2025.',
      coverPosition: 'center 48%',
      gallery: [
        {
          src: '/images/events/universal-dance-merida-mayo-2025-gallery.jpg',
          alt: 'Alumnas de Legacy Dance durante Universal Dance Mérida Mayo 2025.',
          position: 'center 48%',
        },
        {
          src: '/images/events/universal-dance-merida-mayo-2025.jpg',
          alt: 'Presentación de Legacy Dance en Universal Dance Mérida 2025.',
          position: 'center 45%',
        },
      ],
    },
  ],
  schedule: {
    label: 'Horarios confirmados',
    title: 'Lunes y miércoles',
    copy: 'Clases de 5:00 p.m. a 8:00 p.m.',
    cta: 'Consultar por WhatsApp',
  },
  instructors: [
    {
      name: 'Valeria Ramos',
      specialty: 'Jazz · Lírico',
      bio: 'Ex integrante de compañía nacional. 8 años formando talentos en CDMX.',
      image: '/images/legacy/hero-backstage-huddle.jpg',
    },
    {
      name: 'Diego Fuentes',
      specialty: 'Hip Hop · Urbano',
      bio: 'Coreógrafo y performer con presencia en festivales de México y Latinoamérica.',
      image: '/images/legacy/urbano-backstage-legacy.jpg',
    },
    {
      name: 'Sofia Mendoza',
      specialty: 'Jazz · Lírico',
      bio: 'Formación en Bellas Artes y 10 años de docencia en técnica clásica y contemporánea.',
      image: '/images/legacy/contemporaneo-blue-portrait.jpg',
    },
  ],
  gallery: [
    {
      tag: 'Evento',
      title: 'Showcase Anual 2024',
      image: '/images/legacy/jazz-team-celebration.jpg',
      featured: true,
    },
    {
      tag: 'Festival',
      title: 'Festival de Verano',
      image: '/images/legacy/kids-team-celebration.jpg',
    },
    {
      tag: 'Gala',
      title: 'Presentación de Gala',
      image: '/images/legacy/hiphop-first-place.jpg',
    },
    {
      tag: 'Lírico',
      title: 'Temporada Lírico',
      image: '/images/legacy/heels-backstage-focus.jpg',
    },
    {
      tag: 'Showcase',
      title: 'Noche de Talentos',
      image: '/images/legacy/contemporaneo-blue-portrait.jpg',
    },
  ],
  testimonials: [
    {
      quote:
        'Llegué sin saber bailar y hoy subo al escenario con plena confianza. Los instructores te ven, te guían y te hacen crecer de verdad.',
      name: 'Camila Torres',
      meta: 'Jazz · 2 años en Legacy',
    },
    {
      quote:
        'El ambiente es único. No importa tu nivel, te hacen sentir parte de la familia desde el primer día. Es mucho más que un estudio.',
      name: 'Marco Ávila',
      meta: 'Hip Hop · 1 año en Legacy',
    },
    {
      quote:
        'Mi hija encontró su pasión aquí. Los maestros son pacientes, profesionales y realmente se preocupan por cada niño.',
      name: 'Lucía Herrera',
      meta: 'Mamá · Babys',
    },
  ],
  contact: {
    title: 'Da el primer paso hoy',
    copy: 'Tu clase muestra es completamente gratuita. Sin compromisos. Solo tienes que dar el primer paso.',
    whatsappDisplay: '+52 984 188 0526',
    whatsappUrl: 'https://wa.me/529841880526',
    instagram: '@legacydance2025',
    instagramUrl: 'https://www.instagram.com/legacydance2025',
    location: 'Puerto Morelos, Quintana Roo',
    reminder:
      'Visítanos sin compromiso. Solo manda un mensaje y coordinamos tu clase de acuerdo a tu horario.',
  },
  footer: {
    developedBy: 'desarrollado por',
    studioName: 'Ethernal Design',
    studioLogo: '/ethernal-design-white.svg',
    studioUrl: 'https://ethernaldesign.com',
  },
};
